import { Reducer } from "redux";
import produce from "immer";
import { StrategyScannerAction } from "./actions";

export interface StrategyScannerState {
  companyHistory: { companyName: string; meta: string }[];
}

export const initialState: StrategyScannerState = {
  companyHistory: []
};

// 履歴に保持する最大件数
const MAX_HISTORY = 5;

// 経営戦略スキャナー
export const strategyScanner: Reducer<
  StrategyScannerState,
  StrategyScannerAction
> = (state = initialState, action) => {
  switch (action.type) {
    case "strategyScanner/COMPANY_HISTORY_ADD":
      return produce(state, draft => {
        const name = action.payload.companyName.trim();
        if (!name) return;

        const existingIndex = draft.companyHistory.findIndex(
          item => item.companyName === name
        );
        if (existingIndex !== -1) {
          draft.companyHistory.splice(existingIndex, 1);
        }
        // 先頭に追加し、最大件数を超えたものを切り捨てる
        draft.companyHistory.unshift({
          companyName: name,
          meta: action.payload.meta
        });
        if (draft.companyHistory.length > MAX_HISTORY) {
          draft.companyHistory.length = MAX_HISTORY;
        }
      });
    case "strategyScanner/COMPANY_HISTORY_CLEAR":
      return produce(state, draft => {
        draft.companyHistory = [];
      });
    default:
      return state;
  }
};
